/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CreditCardListDirectiveController {

        public static $inject : string[] = [
            '$dealerwareNotification',
            '$dealerwareLoading',
            'MicroFrontendOrigin',
        ];

        public columns: any;
        public customer: any;
        public loader: any;
        public paymentProcessor: any;

        constructor(public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public MicroFrontendOrigin: any,
                    ) {
                var isExpired = (date: string) => {
                return moment(date, 'MM/YYYY').endOf('month').isBefore();
            }

            this.columns = [{
                key: 'id',
                hidden: true
            },{
                key: 'cardholder_name',
                header: 'Name on Card'
            },{
                key: 'id',
                header: 'Type',
                dataFilter: (id: number) => {
                    var cardIdx = this.customer.creditCards.data.findIndex((cc: any) => cc.data.id === id),
                        card = this.customer.creditCards.data[cardIdx].data;

                    return `${card.card_type} ending in ${card.last_four}`;
                }
            },{
                key: 'expiration',
                header: 'Expiration Date',
                dataFilter: (date: string) => {
                    return isExpired(date) ? `Expired ${date}` : date;
                },
                styleFn: (cc: any) => {
                    return isExpired(cc.data.expiration) ? {color: 'red'} : {};
                }
            },{
                key: 'default',
                hidden: true
            }];
        }

        public pageTransitionError(response: any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public redirectCenpos() {
            const newHash = `/${this.customer.locationId}/customers/${this.customer.customerId}/payment-method`;

            window.parent.postMessage({
                type: 'routing',
                hash: newHash
            }, this.MicroFrontendOrigin);
        }
    }

    getDealerwareWebComponentsModule().controller('CreditCardListDirectiveController', CreditCardListDirectiveController);



    export class CreditCardListDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'CreditCardListDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { customer: '=' };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/customer/credit_cards/list_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCustomerCreditCards",() => new CreditCardListDirective());

}
